import React from 'react';
import { CardComponent } from '../CardComponent';


export function EditClient(props) {
  const {
    isLoading,
    handleInputCounter,
    dynamicAge,
    modalBankName,
    setModalBankName,
    modalAbbr,
    setModalAbbr,
    domain,
    setDomain,
    modalStatus,
    setModalStatus,
    customerTypeHandleChange,
    customerTypes,
    modalCustomerTypeValue,
    baseQuestions,
    setBaseQuestion,
    classicQuestions,
    classicQuestionAttribute,
    editCommentCodes,
    setEditCommentCodes,
    editDetails,
    setEditDetails,
    rankingReport,
    setRankingReport,
    advanceActionAlert,
    setAdvanceActionAlert,
    actionAlerts,
    setActionAlerts,
    respondentName,
    setRespondentName,
    respondentEmail,
    setRespondentEmail,
    respondentPhone,
    setRespondentPhone,
    allSurveyHandleChange,
    selectAllSurveyValue,
    allSurveyQuestions,
    singleSurveyHandleChange,
    singleSurveyQuestions,
    selectSingleSurvey,
    updateClient,
    closeEditClientModal,
    individualSurveysDelete,
    setIndividualSurveysDelete,
    usesSampleApp,
    setUsesSampleApp,
    jhInstRouteId,
    setJhInstRouteId,
    jhInstEnv,
    setJhInstEnv
  } = props;

  const title = `Edit  ${modalBankName}`;

  return (
    <CardComponent
      title={title}
      titleStyles={{ display: 'inline-block', fontSize: '2.6rem', fontWeight: 400, marginLeft: '30px', marginTop: '1px0px' }}
      styles={{ position: 'fixed', top: '13%', left: '10%', zIndex: 1050, background: 'white', height: '850px', width: '1000px', border: 'solid grey', borderRadius: '10px', overflow: 'scroll' }}
      isLoading={isLoading}
      disableCardBackgroundColor
    >
      <form
        style={{ overflowY: 'scroll', margin: '20px' }}
      >
        <div className="modal-content">
          <div className="row">
            <div className="col sm12">
              <small>
                <i style={{ color: 'blue !important' }}>
                  All fields are required.
                </i>
              </small>
            </div>
          </div>
          <div className="row">
            <div className="col s12 m6" >
              <label
                data-error="Invalid: Please enter a client name."
                data-success="Valid"
              >
                <span>Client Name</span>
                <input
                  style={{ color: '#282828' }}
                  type="text"
                  value={modalBankName}
                  onChange={(e) => setModalBankName(e.target.value)}
                  className="validate"
                  aria-required="true"
                  required placeholder="e.g. PrimeWay Federal Credit Union"
                />
              </label>
            </div>
            <div className="col s12 m6">
              <label
                data-error="Invalid: Please enter a abbreviation. Letters and numbers only."
                data-success="Valid"
              >
                <span>Abbreviation</span>
                <input
                  disabled
                  type="text"
                  value={modalAbbr}
                  onChange={(e) => setModalAbbr(e.target.value)}
                  className="validate"
                  aria-required="true"
                  required placeholder="e.g. PWFCU"
                  pattern="[a-zA-Z0-9-]+"
                />
              </label>
            </div>
          </div>
          <div className="row">
            <div className="col s12 m3">
              <label
                data-error="Invalid: Please enter a domain."
                data-success="Valid"
              >
                <span>Domain</span>
                <input
                  style={{ color: '#282828' }}
                  type="url"
                  value={domain}
                  onChange={(e) => setDomain(e.target.value)}
                  className="validate"
                  aria-required="true"
                  required placeholder="e.g. primewayfcu.com"
                />
              </label>
            </div>
            <div className="blacklight col s12 m3">
              <label
                // data-error="Invalid: Please enter a domain." 
                // data-success="Valid"
                style={{ color: 'grey', fontSize: '12px' }}
              >
                Status
              </label>
              <select
                className='custom-select'
                onChange={(e) => setModalStatus(e.target.value)}
                value={modalStatus}
              // defaultValue={modalStatus}
              >
                <option value="0">Active</option>
                <option value="1">In-Active</option>
                <option value="2">Testing</option>
              </select>

            </div>
            <div className="blacklight col s12 m3">
              <label
                // data-error="Invalid: Please select a customer type." 
                // data-success="Valid"
                style={{ color: 'grey', fontSize: '12px' }}
              >
                Customer Type
              </label>
              <select
                className="custom-select"
                onChange={customerTypeHandleChange}
                value={modalCustomerTypeValue}
              // defaultValue={modalCustomerTypeValue}
              >
                {customerTypes.map((option) => (
                  <option key={option.id} value={option.id}>{option.name}</option>
                ))}
              </select>
            </div>
            <div className="blacklight col s12 m3">
              <span style={{ color: 'grey', fontSize: '12px' }}>
                Dynamic Age - Days
              </span>
              <input type="number"
                onChange={handleInputCounter}
                value={dynamicAge}
              />
            </div>
          </div>
          <div className="row" style={{ marginBottom: '20px', background: '#EFEFEF', paddingTop: '10px', fontSize: '12px' }}>
            <div className="blacklight col s6">
              <div style={{ height: '25px' }}>
                <label>
                  <input type="checkbox"
                    checked={baseQuestions}
                    onChange={() => { setBaseQuestion(!baseQuestions) }}
                  />
                  <span style={{ marginLeft: '10px' }}>
                    Enable Base Questions
                  </span>
                </label>
              </div>
              <div style={{ height: '25px' }}>
                <label>
                  <input type="checkbox"
                    checked={classicQuestions}
                    onChange={() => { classicQuestionAttribute(classicQuestions, singleSurveyQuestions) }}
                  />
                  <span style={{ marginLeft: '10px' }}>
                    Classic Questions
                  </span>
                </label>
              </div>
              <div style={{ height: '25px' }}>
                <label>
                  <input type="checkbox"
                    checked={editCommentCodes}
                    onChange={() => { setEditCommentCodes(!editCommentCodes) }}
                  />
                  <span style={{ marginLeft: '10px' }}>
                    Edit List of Comment Codes
                  </span>
                </label>
              </div>
              <div style={{ height: '25px' }}>
                <label>
                  <input type="checkbox"
                    checked={editDetails}
                    onChange={() => { setEditDetails(!editDetails) }}
                  />
                  <span style={{ marginLeft: '10px' }}>
                    Edit codes assigned to individual comments
                  </span>
                </label>
              </div>
              <div style={{ height: '25px' }}>
                <label>
                  <input type="checkbox"
                    checked={rankingReport}
                    onChange={() => { setRankingReport(!rankingReport) }}
                  />
                  <span style={{ marginLeft: '10px' }}>
                    Enable Ranking Reports
                  </span>
                </label>
              </div>
              <div style={{ height: '25px' }}>
                <label>
                  <input
                    type="checkbox"
                    checked={advanceActionAlert}
                    onChange={() => { setAdvanceActionAlert(!advanceActionAlert) }}
                  />
                  <span style={{ marginLeft: '10px' }}>
                    Enable Advanced Action Alerts
                  </span>
                </label>
              </div>
              <div style={{ height: '25px' }}>
                <label>
                  <input
                    type="checkbox"
                    checked={actionAlerts}
                    onChange={() => { setActionAlerts(!actionAlerts) }}
                  />
                  <span style={{ marginLeft: '10px' }}>
                    Enable Action Alerts
                  </span>
                </label>
              </div>
              <div style={{ height: '25px' }}>
                <label>
                  <input
                    type="checkbox"
                    checked={usesSampleApp}
                    onChange={() => { setUsesSampleApp(!usesSampleApp) }}
                  />
                  <span style={{ marginLeft: '10px' }}>
                    Uses Sample App
                  </span>
                </label>
              </div>
            </div>

            <div className="col s6 blacklight">
              <div style={{ fontSize: '14px' }}>
                <span>
                  Respondent Name Fieldname:
                </span>
                <input style={{ height: '20px', marginTop: '10px', marginBottom: '10px' }}
                  value={respondentName}
                  onChange={(e) => setRespondentName(e.target.value)}
                  type="text"
                  placeholder=""
                />
                <span style={{ marginTop: '10px' }}>
                  Respondent Email Fieldname:
                </span>
                <input style={{ height: '20px', marginTop: '10px', marginBottom: '10px' }}
                  value={respondentEmail}
                  onChange={(e) => setRespondentEmail(e.target.value)}
                  type="text"
                  placeholder=""
                />
                <span style={{ marginTop: '10px' }}>
                  Respondent Phone Fieldname:
                </span>
                <input style={{ height: '20px', marginTop: '10px', marginBottom: '10px' }}
                  value={respondentPhone}
                  onChange={(e) => setRespondentPhone(e.target.value)}
                  type="text"
                  placeholder=""
                />
                <span style={{ marginTop: '10px' }}>
                  Jack Henry Institution Route ID:
                </span>
                <input style={{ height: '20px', marginTop: '10px', marginBottom: '10px' }}
                  value={jhInstRouteId}
                  onChange={(e) => setJhInstRouteId(e.target.value)}
                  type="text"
                  placeholder=""
                />
                <span style={{ marginTop: '10px' }}>
                  Jack Henry Institution Environment:
                </span>
                <input style={{ height: '20px', marginTop: '10px', marginBottom: '10px' }}
                  value={jhInstEnv}
                  onChange={(e) => setJhInstEnv(e.target.value)}
                  type="text"
                  placeholder=""
                />
              </div>
            </div>
          </div>
          {/* <div className='row'>
            <div className="col s6 blacklight">
            </div>
          </div> */}
          <div className="row" style={{ marginTop: '10px' }}>
            <div className="blacklight col s12 m6">
              <div>
                <label style={{ color: 'grey', fontSize: '12px' }}
                // data-error="Invalid: Please select a default question." 
                // data-success="Valid"
                >
                  All Surveys Default Question
                </label>
              </div>
              <select disabled
                id='allQuestionSelect'
                className="custom-select "
                onChange={allSurveyHandleChange}
                value={selectAllSurveyValue}
                defaultValue={selectAllSurveyValue}
              >
                {allSurveyQuestions.map((option, index) => (
                  <option key={index} value={option.value}>{option.text}</option>
                ))}
              </select>
            </div>
            <div className="blacklight col s12 m6" style={{ marginBottom: '10px' }}>
              <div style={{ marginTop: '10px', marginLeft: '10px' }}>
                <label style={{ color: 'grey', fontSize: '12px' }}>
                  Single Survey Default Questions
                </label>
              </div>
              <div>
                {singleSurveyQuestions.map((option, index) => (
                  <div key={index}>
                    {(option.selected ?
                      <div className='blacklight'>
                        {classicQuestions ? "" :
                          <a
                            style={{ color: '#e42f2f !important', cursor: 'pointer' }}
                            onClick={() => {
                              const value = option.value;
                              singleSurveyHandleChange(value, singleSurveyQuestions)
                            }}
                          >
                            <i className="h5 material-icons">delete</i>
                          </a>
                        }
                        <label style={{ fontSize: '14px', marginLeft: '10px' }}>{option.text}
                        </label>
                      </div>
                      : "")}
                  </div>
                ))}
              </div>
              <div style={{ marginTop: '10px' }}>
                <label style={{ color: 'grey', fontSize: '12px' }}>
                  Add Single Survey Default Questions
                </label>
              </div>
              <div>
                <select disabled
                  id='singleQuestionSelect'
                  className="custom-select"
                  onChange={(e) => {
                    const value = e.target.value;
                    singleSurveyHandleChange(value, singleSurveyQuestions)
                  }}
                  value={selectSingleSurvey}
                // defaultValue='select option'
                >
                  <option>Select Question</option>
                  {singleSurveyQuestions.filter(function (option) {
                    return option.selected === false;
                  }).map((option, index) => (
                    <option key={index} value={option.value}>{option.text}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer" style={{ marginBottom: '10px' }}>
          {isLoading ? "" :
            <div>
              <a
                onClick={() => { updateClient() }}
                className="btn btn-action"
                style={{ marginLeft: '10px', marginRight: '8px', marginBottom: '10px' }}
              >
                Save
              </a>
              <a
                onClick={closeEditClientModal}
                className="btn btn-white"
                style={{ marginBottom: '10px' }}
              >
                Cancel
              </a>
            </div>
          }
        </div>
      </form>
    </CardComponent>
  );
}
